import { createFrontendModule } from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';

export const techdocsEntityContent = techdocsPlugin
  .getExtension('entity-content:techdocs')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        config: {
          ...config,
          title: 'Docs',
          filter: {
            $any: [
              {
                'metadata.annotations.backstage.io/techdocs-ref': {
                  $exists: true,
                },
              },
              {
                'metadata.annotations.backstage.io/techdocs-entity': {
                  $exists: true,
                },
              },
            ],
          },
        },
      });
    },
  });

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsEntityContent],
});
